<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.type === 'representative'"
        type="info"
        size="small"
      >
        Képviselői
      </el-tag>
      <el-tag
        v-else
        size="small"
      >
        Központi
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'type',
};
</script>
